import React, { Fragment } from 'react';

// Import routing components
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Import custom components
// import MainLayout from '../components/common/layout/MainLayout';
import NotFound from '../components/error/NotFound';

import PublicRoute from './PublicRoute'; // Pre auth routes
import FullyPublicRoute from './FullyPublicRoute'; // Pre auth routes
import PrivateRoute from './PrivateRoute'; // If not auth, re-route to '/'

// Pre-Security
import LandingPageCont from '../containers/pre-security/LandingPageContainer';
import Vis2dCont from '../containers/pre-security/Vis2dContainer';
import Deliveries from '../containers/pre-security/Deliveries';
import PHD from '../containers/pre-security/PHD';
// import DashboardScheduleViewer from '../containers/pre-security/DashboardScheduleViewer';
// import TvScreenContainer from '../containers/pre-security/TvScreenContainer';

// Post-Security
// Roster
import PMsCont from '../containers/post-security/PMsContainer';
import ProjectsViewCont from '../containers/post-security/ProjectsViewContainer';
import PAsCont from '../containers/post-security/PAsContainer';
import SupersCont from '../containers/post-security/SupersContainer';
import SettingsCont from '../containers/post-security/SettingsContainer';

// Lessons Learned
import LLViewContent from '../ll/containers/post-security/activity-view/LLViewContent';
import LessonsView from '../ll/containers/post-security/lessons-view/LessonsView';
import NewLessonView from '../ll/containers/post-security/new-lesson/NewLesson';
import AuthCallback from '../components/auth/authCallback';


const Router = () => {
    return (
        <Fragment>
                <BrowserRouter>
                    <Routes>
                        <Route path="/vis2d/:long_bay_spacing/:long_bay_spacing_details/:short_bay_spacing/:short_bay_spacing_details/" element={<PublicRoute element={<Vis2dCont />} path="/vis2d/:long_bay_spacing/:long_bay_spacing_details/:short_bay_spacing_details/:short_bay_spacing_details" />} />
                        <Route path="/" element={<PublicRoute element={<LandingPageCont />} path="/" />} />
                        {/* <Route path="/dashboard_schedule_viewer/:company_slug?" element={<PublicRoute element={<DashboardScheduleViewer />} path="/dashboard_schedule_viewer/:company_slug?" />} /> */}
                        {/* <Route path="/banner" element={<FullyPublicRoute element={<Deliveries />} path="/banner" />} /> */}
                        {/* <Route path="/westseattle" element={<FullyPublicRoute element={<Deliveries />} path="/westseattle" />} /> */}
                        <Route path="/phd" element={<FullyPublicRoute element={<PHD />} path="/phd" />} />
                        <Route path="/auth/callback" element={<PublicRoute element={<AuthCallback />} path="/auth/callback" />} />       
                        
                        <Route path="/pm-view" element={<PrivateRoute element={<PMsCont />} path="/pm-view" />} />
                        <Route path="/project-view" element={<PrivateRoute element={<ProjectsViewCont />} path="/project-view" />} />
                        {/* <Route path="/pa-view" element={<PrivateRoute element={<PAsCont />} path="/pa-view" />} /> */}
                        <Route path="/super-view" element={<PrivateRoute element={<SupersCont />} path="/super-view" />} />
                        <Route path="/custom-settings" element={<PrivateRoute element={<SettingsCont />} path="/custom-settings" />} />

                        <Route path="/ll/view/:lesson_id?" element={<PrivateRoute element={<LLViewContent />} path="/ll/view/:lesson_id?" />} />
                        <Route path="/ll/lessons" element={<PrivateRoute element={<LessonsView />} path="/ll/lessons" />} />
                        <Route path="/ll/new-lesson/:lesson_id?" element={<PrivateRoute element={<NewLessonView />} path="/ll/new-lesson/:lesson_id?" />} />

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
        </Fragment>
    )
};

export default Router;